import React, { useContext } from 'react'
import Like from '../assests/images/like.svg'
import Dislike from '../assests/images/dislike.svg'
import diamond from '../assests/images/diamond.svg'
import Play_btn from '../assests/images/PLay_btn.svg'
import { Link } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { likeDislike } from '../utils/Api'
import { DataContext } from '../context/DataContext'
import { useQueryClient } from '@tanstack/react-query';


const GameList = (props) => {
  const queryClient = useQueryClient();
  const { data: contextData, loading, error, refetch } = useContext(DataContext);

  const { mutate } = useMutation({
    mutationFn: async ({ user_id, contest_id, selection_type, idtoken }) => await likeDislike({ user_id, contest_id, selection_type, idtoken }),
    onSuccess: () => {
      queryClient.invalidateQueries(['allGameList']);
    },
  })

  return (
    <div>
      {props.gamel != null &&
        props.gamel.map((data, index) => {
          return (
            <div className="card22 d_flx2 card_list">
              <div className="top_img_card2">
                <img
                  src={data.app_icon_transparent}
                  alt="knife"
                  className="card2_main_img img_sq"
                />
              </div>
              <div className="mt_5per colmn">
                <div className="displ_lr">
                  <p className="ttl_bg">{data.title}</p>
                  {/* Optional: If this needs to be clickable, move it OUTSIDE the main anchor */}
                  <img
                    src={data.is_liked == '1' ? Like : Dislike}
                    onClick={() => {
                      // console.log(first)
                      data?.is_liked == '1' ? mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 0, idtoken: contextData?.idtoken }) : mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 1, idtoken: contextData?.idtoken })
                    }}
                    alt="like"
                    className="view_more_btn brdr_none"
                  />
                </div>
                <p className="desc">{data.contest_description}</p>
                <div className="win_daim btn_tp mt_5per">
                  <img src={diamond} alt="diamond" />
                  {data.total_prize}
                </div>
                <Link to={`/Details/${data.contest_id}`}>
                  <button className="play_now brdr_10">
                    <img src={Play_btn} alt="play" />
                    Play to Earn
                  </button>
                </Link>
              </div>
            </div>

          )
        })
      }
    </div>

  )
}

export default GameList
